export const MakeupArr = [
    {
        "id": 1,
        "name": "CERTIFICATE IN BASIC TO ADVANCED MEHENDI DESIGN (CBAMD)",
        "course_info": "This artistic course takes you from traditional patterns to intricate bridal Mehendi designs. You will learn the science of henna, cone control, and various styles including Arabic, Indian, and contemporary fusion. Perfect for starting a professional career as a Mehendi artist.",
        "eligibility_critaria": "13 years Above",
        "course_duration": "5 months",
        "syllabus_highlight": "ISO Certification, Hands on Practice, Organic Mehendi Making Process, All kind of Ritual Mehendi Design, Bridal Mehendi, Arebic Mehendi, Rajasthani Mehendi, Cone Making Process & Business Strategy, Social Media Handling Trick",
        "fees_structure": {
            "one_time_amount" : "4,130",
            "emi_total_amount" : " 5,310" 
        }
    },
    {
        "id": 2,
        "name": "CERTIFICATE IN PROFESSIONAL BRIDAL MAKEUP (CPBMF)",
        "course_info": "Master the art of transforming brides for their big day. You will learn skin preparation, base application, and cultural bridal looks ranging from traditional to modern styles. This course provides technical confidence for the lucrative wedding and bridal industry.",
        "eligibility_critaria": "13 years Above",
        "course_duration": "3 months",
        "syllabus_highlight": "We offer product for Practice Class, Hands On Practice, Kolka and Saree Drapping included, all kinds of Bridal MakeUp, Product Knowledge, Social Media Profile Handling, Business Strategy.",
        "fees_structure": {
            "one_time_amount" : " 5,900",
            "emi_total_amount" : " 7,080" 
        }
    },
    {
        "id": 3,
        "name": "CERTIFICATE IN ADVANCED MAKEUP MASTER CLASS (CAMMC)",
        "course_info": "Elevate your skills to an editorial and high-fashion level. Focus on advanced techniques such as airbrushing, theatrical makeup, and color correction. It is the perfect choice for artists wanting to work in film, television, or professional fashion photography.",
        "eligibility_critaria": "13 years Above",
        "course_duration": "4 Months",
        "syllabus_highlight": "Professionally Model Handling, Advanced product knowledge, All kinds of Bridal Makeup, Advanced Process, Prothetic Makeup, Illusion MakeUp, Advanced Kolka Practice, Hands On Practice, Original Flower Jwellery Making, Flower Gajra Making, Mobile Photography",
        "fees_structure": {
            "one_time_amount" : " 9,440",
            "emi_total_amount" : " 10,620"
        }
    },
    {
        "id": 4,
        "name": "CERTIFICATE IN BASIC TO ADVANCED NAIL ART (CBANA)",
        "course_info": "Turn nails into canvases. Learn basic manicures to complex 3D nail art, extensions, and the latest trends.",
        "eligibility_critaria": "13 years Above",
        "course_duration": "3 Months",
        "syllabus_highlight": "Basic to Advanced, Hands on practice on original nails, 3D, 5D Cats Eye, Acrylic 3D Flower, Bubble Nail Art, Blossom Gel Nail Art, Any Trending Nail Art, Business Strategy , Social Media Handling",
        "fees_structure": {
            "one_time_amount" : " 5,310",
            "emi_total_amount" : " 6,490"
        }
    },
    {
        "id": 5,
        "name": "CERTIFICATE IN BASIC TO ADV SKIN THERAPY (CBAST)",
        "course_info": "Understand the science of healthy skin and professional treatment protocols. This course covers various skin types, facial techniques, and advanced therapies for common skin concerns. Provides a solid foundation for skin consultants or professional estheticians.",
        "eligibility_critaria": "13 years Above",
        "course_duration": "3 Months",
        "syllabus_highlight": "Skin Analysis, Skin Treatment, O3+ Facial, Tan Removing Facial, Age Control Facial, Korean Wax, Crystal Manicure and Pedicure, Hands on Practice, Ozon Facial, Galvanic Facial, UV Mask Therapy",
         "fees_structure": {
            "one_time_amount" : " 3,200",
            "emi_total_amount" : " 3,700"
        }
    },
     {
        "id": 6,
        "name": "CERTIFICATE IN BASIC TO ADV HAIR THERAPY (CBAHT)",
        "course_info": "Become an expert in hair care and advanced chemical treatments. You will learn hair anatomy, professional cutting techniques, coloring, and therapeutic treatments for hair health. Essential for becoming a professional hairstylist or therapist.",
        "eligibility_critaria": "13 years Above",
        "course_duration": "4 Months",
        "syllabus_highlight": "Hair Analysis, Basic to Advanced Hair Colour, Basic to Advanced Hair Cutting, Anti Hairfall Treatment, Frizzy Hair Treatment, Anti Hairfall Treatment, Hair Ozon Treatment, Advanced Hair Hydrating Therapy.",
         "fees_structure": {
            "one_time_amount" : " 4,200",
            "emi_total_amount" : " 4,700"
        }
    }
]